import gsap from "gsap";
import { ANIMATION, animateObserver, animateWords, unmaskOuter, parallaxHorizontal } from "../../../js/animations/animations";
import { isAuthor, isMobile } from "../../../js/utils";
import CLASSES from "./utils/class";

(() => {
  "use strict";

  const BRHHeroCollage = () => {
    const init = () => {
      if (!isMobile() && !isAuthor()) {
        const sliderGrid = document.querySelectorAll(".brh-hero-collage__slider-grid");
        sliderGrid.forEach((el) => {
          el.classList.add("brh-hero-collage__slider-grid--publish");
        });

        let isDragging = false;
        let initialTranslateX;
        let translateX = 0;
        let endTranslate = 0;

        const sliderWrapper = document.querySelector(CLASSES.selector.animateSlider);
        if (sliderWrapper) {
          const slider = document.querySelector(".brh-hero-collage__slider");
          const limitEndDragging = (sliderWrapper.scrollWidth - slider?.clientWidth) * -1;
          sliderWrapper.querySelectorAll(CLASSES.image).forEach((el) => {
            el.style.setProperty("--scale-image", 1.2);
          });

          const ensureSliderVisible = () => {
            if (endTranslate > 0) {
              translateX = 0;
            }

            if (limitEndDragging > endTranslate) {
              translateX = limitEndDragging;
            }

            sliderWrapper.style.transform = `translate3d(${translateX}px, 0, 0)`;
          };

          sliderWrapper.addEventListener("mousedown", (e) => {
            isDragging = true;
            initialTranslateX = e.pageX - translateX;
            sliderWrapper.querySelectorAll(CLASSES.image).forEach((el) => {
              el.style.setProperty("--scale-image", 1);
            });
            sliderWrapper.style.transition = "none";
          });

          sliderWrapper.addEventListener("mousemove", (e) => {
            if (isDragging) {
              const newX = e.pageX - initialTranslateX;
              endTranslate = newX;
              sliderWrapper.style.transform = `translate3d(${newX}px, 0, 0)`;
              sliderWrapper.style.transition = "transform 0.1s linear";
            } else {
              return;
            }
          });

          sliderWrapper.addEventListener("mouseup", () => {
            isDragging = false;
            translateX = parseInt(sliderWrapper.style.transform.replace("translate3d(", "").split(",")[0]) || 0;
            sliderWrapper.querySelectorAll(CLASSES.image).forEach((el) => {
              el.style.setProperty("--scale-image", 1.2);
            });
            sliderWrapper.style.transition = "transform 0.5s ease-in-out";
            ensureSliderVisible();
          });

          sliderWrapper.addEventListener("mouseleave", () => {
            if (isDragging) {
              isDragging = false;
              translateX = parseInt(sliderWrapper.style.transform.replace("translate3d(", "").split(",")[0]) || 0;
            }
          });
        }

        /*** ANIMATIONS ***/
        const heroesCollage = document.querySelectorAll(CLASSES.main);
        if (heroesCollage.length > 0) {
          heroesCollage.forEach((element) => {
            const appearances = gsap.timeline();
            const titles = element.querySelectorAll(ANIMATION.selectors.animatedWords);
            titles.length > 0 && appearances.add(animateWords({ classElement: titles }), 0);
            const multimedias = element.querySelectorAll(ANIMATION.selectors.unmaskFromOuter);
            multimedias.length > 0 && appearances.add(unmaskOuter({ classElement: multimedias }), 0);

            appearances.duration(2);
            appearances.pause();

            parallaxHorizontal({ classElement: ".brh-hero-collage__slider", trigger: CLASSES.main, start: 80, end: -120 });
            animateObserver({ elementToObserve: element, animation: () => appearances, threshold: 0 });
          });
        }
      }
    };

    init();
  };

  document.addEventListener("DOMContentLoaded", BRHHeroCollage);
})();
